<script>
import useSharedData from "@/use/SharedData.js";
import {ref} from "vue";
import useTools from "@/use/Tools.js";
import useSharedMethod from "@/use/SharedMethod.js";
import {useDebtStore} from "@/stores/Debt.js";
import useValidation from "@/use/Validation.js";
import axios from "axios";

export default {
    setup() {
        const {loading, dialog, inputColor, backgroundColor} = useSharedData();
        const {$refs, $route} = useTools();
        const {getBack} = useSharedMethod();
        const {mxRules} = useValidation();
        const debtStore = useDebtStore();
        const refund = ref({
            type: "CASH",
        });
        const date = ref(null);

        function save() {
            if ($refs.form.validate()) {
                loading.value = true;
                axios.put(`/debts/add/cash/${$route.params.id}`, refund.value).then((response) => {
                    debtStore.updateDebt(response.data);
                    getBack();
                }).finally(() => {
                    loading.value = false;
                });
            }
        }

        return {
            mxRules,
            loading,
            dialog,
            inputColor,
            backgroundColor,
            refund,
            date,
            save,
            getBack,
        }
    },
};
</script>

<template>
    <v-dialog
        transition="dialog-bottom-transition"
        v-model="dialog"
        persistent
        max-width="400"
    >
        <v-card>
            <w-toolbar color="teal" :title="$t('debts.add_cash')"/>
            <v-divider/>
            <v-card-text>
                <v-container fluid>
                    <v-form ref="form" lazy-validation>
                        <v-row>
                            <v-col cols="12">
                                <w-label :label="$t('common.amount')" required/>
                                <w-text-field
                                    v-model="refund.price"
                                    :rules="[mxRules.required, mxRules.integer]"
                                    type="number"
                                    min="1"
                                />
                            </v-col>
                            <v-col cols="12">
                                <w-label :label="$t('common.date')" required/>
                                <w-date-picker
                                    v-model="refund.date"
                                    :rules="[mxRules.required]"
                                />
                            </v-col>
                            <v-col cols="12">
                                <w-label :label="$t('common.observation')"/>
                                <w-simple-text-area
                                    v-model="refund.observation"
                                />
                            </v-col>
                        </v-row>
                    </v-form>
                </v-container>
            </v-card-text>
            <v-divider/>
            <v-card-actions>
                <v-spacer/>
                <w-btn-close @press="getBack"/>
                <w-btn-add
                    :show="true"
                    :loading="loading"
                    @press="save"
                />
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>